import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { WithPNOColleaguesRequest, WithPNOColleaguesResult } from '../../../features/linking-with-pno-colleagues/models/with-pno-colleagues-request.intraface'

export const setWithPNOColleaguesDisplayLayoutList = createAction('[f-linking-tool] Linking with PNO colleagues - display layout: LIST')

export const setWithPNOColleaguesDisplayLayoutGrid = createAction('[f-linking-tool] Linking with PNO colleagues  - display layout: GRID')

export const getWithPNOColleaguesData = createAction(
   '[f-linking-tool] Linking with PNO colleagues - GETTING data',
   props<{ request: WithPNOColleaguesRequest }>()
)

export const getWithPNOColleaguesDataSuccess = createAction(
   '[f-linking-tool] Linking with PNO colleagues - GETTING data SUCCESS',
   props<{ data: WithPNOColleaguesResult }>()
)

export const getWithPNOColleaguesDataFailure = createAction(
   '[f-linking-tool] Linking with PNO colleagues - GETTING data FAILURE',
   props<{ error: HttpErrorResponse }>()
)

export const resetWithPNOColleaguesState = createAction('[f-linking-tool] Linking with PNO colleagues  - RESET DATA')
